// @flow
import type {Type} from './typedef';

type ActionType = {|
    type: Type,
    response?: any,
    error?: any,
    payload?: {
        data: any,
        meta: any,
        error: boolean,
        success: boolean,
    },
    [key: string]: any,
|};

type StoreAPI = {|
    dispatch: (action: ActionType) => any,
    getState: () => any,
|};

type Result = {|
    ...ActionType,
    type: string,
|};
type NextFunction = (action: ActionType) => Result;

type ResponseToPayload = (storeAPI: StoreAPI) => (next: NextFunction) => (action: ActionType) => Result;

export const responseToPayload: ResponseToPayload = storeAPI => next => action => {
    if (typeof action.type === 'function') {
        const {response, error, ...meta} = action;
        const type = action.type().type;

        return next({
            type,
            payload: {
                data: response || error,
                meta,
                error: Boolean(error),
                success: !error
            }
        });
    }
    return next(action);
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
